import type { Subscription } from 'rxjs/Subscription';
import type { StoreActionApi } from '@atlassian/react-sweet-state';
import { getTicketTypeIdsByGroupId } from '../../selectors';
import type { ImmutableState } from '../../types';
import type { ActionCallback } from '../types';
import updateTicketTypesByGroup from '../update-ticket-types-by-group';

const reorderTicketTypes =
	(groupId: number, from: number, to: number, callback: ActionCallback<undefined>) =>
	({ getState, dispatch }: StoreActionApi<ImmutableState>): Subscription => {
		const state = getState();
		const oldOrder = getTicketTypeIdsByGroupId(state, groupId) || [];
		const newOrder = oldOrder.slice();
		const moveItem = newOrder.splice(from, 1)[0];
		newOrder.splice(to, 0, moveItem);

		return dispatch(updateTicketTypesByGroup(groupId, newOrder, state, callback));
	};

export default reorderTicketTypes;
